import { createContext, useEffect, useState } from "react";
import { googleSignIn, loginUser, registerUser } from "../api/auth";

export const AuthContext = createContext();

const normalizeRole = (role) => String(role || "").toLowerCase();

const persistSession = (payload) => {
  if (!payload?.token || !payload?.user) {
    throw new Error("Authentication response is incomplete.");
  }

  localStorage.setItem("token", payload.token);
  localStorage.setItem("user", JSON.stringify(payload.user));

  return payload.user;
};

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("user");
      const storedUser = raw && raw !== "undefined" ? JSON.parse(raw) : null;

      if (storedUser) {
        setUser(storedUser);
      }
    } catch (error) {
      console.error("Failed to parse user from localStorage:", error);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    } finally {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const payload = await loginUser(email, password);
    const nextUser = persistSession(payload);
    setUser(nextUser);
    return { ...payload, user: nextUser, role: normalizeRole(nextUser.role) };
  };

  const loginWithGoogle = async (credential) => {
    const payload = await googleSignIn(credential);
    const nextUser = persistSession(payload);
    setUser(nextUser);
    return { ...payload, user: nextUser, role: normalizeRole(nextUser.role) };
  };

  const register = async (userData) => {
    await registerUser(userData);
    return login(userData.email, userData.password);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  return (
    <AuthContext.Provider
      value={{ user, login, loginWithGoogle, logout, loading, register, setUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
